import React from 'react';

import Header from './Heading';
import { useState } from 'react';
import TextInput from './TextInput';
import { useNavigate } from 'react-router-dom';

export default function KayakingGeo({ }) {
    const [locationSlug, setLocationSlug] = useState(null);
    const navigate = useNavigate();

    const update = (e) => {
        setLocationSlug(e.target.value);
    };


    return <div className='mt-5 p-4  shadow-md'>
        <Header text={<span>Kayaking Geo</span>} type="h3" />

        <div className="flex mt-3 items-center">
            <div className="mr-2">Update Location</div>
            <div className="mr-2">
                <TextInput value={locationSlug} onChange={update} placeholder={'Location Slug'} />
            </div>
            <div>
                <button
                    onClick={(e) => {
                        navigate(`/kayaking-geo/${locationSlug}`);
                    }}
                    className="bg-blue-500 mt-2 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                >
                    Submit
                </button>
            </div>
        </div>
    </div>
}